/**
 * Aura Share Certificate (ordinary shares) preset (my_preset / sg / aura / share-cert) — 자체완결 모듈, 자체등록.
 *
 * 매칭 = task code CAU008 (Aura 접두어 CAU). priority 60.
 * 배선: sg/aura/index.ts 가 이 모듈을 import 하면 로드 시 자동 등록.
 *
 * 문서 1종 = Share Certificate (ordinary shares) — 증권 1부(수동 입력).
 *   회사 정보는 선택한 회사에서 자동, 증권번호·주주·주식수·발행일은 입력, 서명 = 이사 1 · 비서 1.
 *   템플릿: 차세대/프리셋/SG/마이프리셋/Aura/Share Cert/_lettaga_templatized/Share Certificate (ordinary shares).docx
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAuraShareCertPanel from './components/PreSetAuraShareCertPanel.vue';
import { auraShareCertFlow } from './chatflows/auraShareCertFlow';

export { default as PreSetAuraShareCertPanel } from './components/PreSetAuraShareCertPanel.vue';
export { auraShareCertFlow } from './chatflows/auraShareCertFlow';

/** 공통코드 — Aura Share Certificate (ordinary shares) 는 CAU008 로 발급됨. */
export const AURA_SHARE_CERT_TASK_CODES: string[] = ['CAU008'];

export function matchesAuraShareCert(sel: PreSetSelection): boolean {
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AURA_SHARE_CERT_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAuraShareCertPreset(): void {
  registerChatFlow(auraShareCertFlow);
  registerPanel({
    id: 'aura-share-cert',
    priority: 60,
    match: (sel) => matchesAuraShareCert(sel),
    component: PreSetAuraShareCertPanel,
    meta: { docType: 'SG_AURA_SHARE_CERT', studio: true },
  });
}

registerAuraShareCertPreset();
